import { queryDataExt } from "../BaseService/index";
const GlobalConfig = new window.globalConfig();

export const getTestsWithConditions = async (
  whereClause,
  selectFields,
  sortFields
) => {
  return await queryDataExt(
    `${GlobalConfig.REACT_APP_API_WALNUT_TEST_URL}getWithConditions`,
    whereClause,
    selectFields,
    sortFields
  );
};